module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/81RyBT/tc-custom/9780544187054.jpg?1709176957376",
      "alt": "This image is the cover for the book Joy Fit Club"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Joy Fit Club\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("Today")]), _vm._v(" show nutrition expert shares over 75 recipes, dramatic weight-loss success stories, and ")]), _c('b', [_vm._v("ten simple rules for healthy everyday eating.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Joy Bauer, the long-time on-air diet and nutrition expert for the "), _c('i', [_vm._v("Today")]), _vm._v(" show, regularly tells the inspiring personal stories of people who have lost one hundred pounds or more using her weight-loss plan. Joy’s diet plan not only works, it really works."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Now, you can take the Joy Fit challenge and use these delicious, bountiful recipes and meal plans at home to start losing weight today. The Joy Fit Club is the one tool you'll need to succeed! Featuring more than 75 recipes, detailed meal plans, and motivational before-and-after photographs of real people, this book is ideal for anyone who wants to join the Joy Fit Club.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joy Bauer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0